import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10859959"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "navbar__list navbar__list--title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "navbar__title" }, "Link List", -1))
const _hoisted_4 = {
  key: 0,
  class: "navbar__list navbar__list--button"
}
const _hoisted_5 = {
  key: 1,
  class: "navbar__list navbar__list--button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_l_buttom_menu = _resolveComponent("l-buttom-menu")!
  const _component_l_buttom = _resolveComponent("l-buttom")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "link",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_l_buttom_menu, {
        "onShow:menu": _ctx.showMenu,
        isToggle: _ctx.menuToggle
      }, null, 8, ["onShow:menu", "isToggle"])
    ]),
    _createElementVNode("ul", {
      id: "navbar__menu",
      class: "navbar__menu",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showMenu && _ctx.showMenu(...args)))
    }, [
      (!_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            (_ctx.this_route)
              ? (_openBlock(), _createBlock(_component_l_buttom, {
                  key: 0,
                  class: "fix-widht",
                  onClick: _ctx.toggleSwitchLogin,
                  text: _ctx.switchLogin ? 'Register' : 'Login'
                }, null, 8, ["onClick", "text"]))
              : _createCommentVNode("", true),
            (!_ctx.this_route)
              ? (_openBlock(), _createBlock(_component_l_buttom, {
                  key: 1,
                  class: "fix-widht",
                  onClick: _cache[0] || (_cache[0] = () => this.$router.push('/')),
                  text: "Register"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createVNode(_component_l_buttom, {
              class: "fix-widht",
              onClick: _cache[1] || (_cache[1] = () => this.$router.push(`/${_ctx.user}`)),
              text: "Profile"
            }),
            _createVNode(_component_l_buttom, {
              class: "fix-widht",
              onClick: _cache[2] || (_cache[2] = () => this.$router.push('/home')),
              text: "Home"
            }),
            _createVNode(_component_l_buttom, {
              class: "fix-widht",
              onClick: _ctx.close,
              text: "Close"
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}